import { html } from 'lit';
import { translate } from 'lit-translate';
import { container } from 'tsyringe';
import { CommandBus } from '../services/command-bus.service';
import { TasklistToggleViewCommand } from '../commands/tasklist-toggle-view.command';
import { TimelineToolbarItem } from '../types/timeline-toolbar-item.interface';

/**
 * Toolbar item for toggling the tasklist view mode.
 *
 * Dispatches TasklistToggleViewCommand via CommandBus on click.
 * The button label is rendered via CSS ::after with `content: attr(data-label)`,
 * reading the translated text from the data-label attribute.
 */
export const tasklistToggleViewToolbarItem: TimelineToolbarItem = {
    id: 'tasklist-toggle-view',
    position: 'start',
    order: 10,
    render: () => {
        return html`
            <button type="button"
                    class="toggle-view buttonform-marker secondary"
                    data-label="${translate('toolbar.tasklistToggleView')}"
                    @click=${() => container.resolve(CommandBus).dispatchCommand(new TasklistToggleViewCommand())}
            >
                <div class="hover-effect"></div>
            </button>
        `;
    },
};
